import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }

   getReportMonthly(mmspId, data): Observable<any> {
      mmspId = this.normalizeId(mmspId);
      data = this.normalizeReportParams(data);
      return this.http.get(environment.endpoints.report + '/' + mmspId + '/monthlies', {
        params: this.buildMonthlyParams(data)
      });
    }

  private buildMonthlyParams(data) {
    let params = new HttpParams()
      .set('month', String(data.month))
      .set('year', String(data.year));

    const orgIds = data.orgIds || [];
    orgIds.forEach(id => {
      params = params.append('orgIds', String(id));
    });

    if (data.msp) {
      params = params.set('msp', String(data.msp));
    }

    return params;
  }

  private normalizeReportParams(data) {
    if (!data) {
      return data;
    }

    const orgIds = this.normalizeIdList(data.orgIds);
    return {
      ...data,
      orgIds,
      msp: this.normalizeId(data.msp)
    };
  }

  private normalizeIdList(value) {
    let ids = Array.isArray(value) ? value : (value ? [value] : []);
    ids = ids
      .map(id => this.normalizeId(id))
      .filter(id => id && id !== 'undefined');

    if (ids.indexOf('All') > -1) {
      return ['All'];
    }

    return ids;
  }

  private normalizeId(id, depth = 0) {
    if (!id || depth > 5) {
      return '';
    }

    if (typeof id === 'object') {
      return this.normalizeId(id._id || id.orgId || id.id || id.organization || '', depth + 1);
    }

    id = String(id);
    if (id.includes('_')) {
      id = id.split('_').pop();
    }

    return id;
  }
}
